import { createStructuredSelector } from 'reselect'

import {
    ROUTE_ADMINISTRATION_GROUP,
    ROUTE_ADMINISTRATION_GROUP_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_ERROR,
    DOSAGE_FORM_GROUP,
    DOSAGE_FORM_GROUP_SUCCESS,
    DOSAGE_FORM_GROUP_ERROR,
    ROUTE_ADMINISTRATION,
    ROUTE_ADMINISTRATION_SUCCESS,
    ROUTE_ADMINISTRATION_ERROR,
    DOSAGE_FORM,
    DOSAGE_FORM_SUCCESS,
    DOSAGE_FORM_ERROR,
    DISPENSING_UNIT,
    DISPENSING_UNIT_SUCCESS,
    DISPENSING_UNIT_ERROR,
    UNSPSC,
    UNSPSC_SUCCESS,
    UNSPSC_ERROR,
    UNSPSC_FAMILY,
    UNSPSC_FAMILY_SUCCESS,
    UNSPSC_FAMILY_ERROR,
    UNSPSC_CLASS,
    UNSPSC_CLASS_SUCCESS,
    UNSPSC_CLASS_ERROR,
    ACTIVE_INGREDIENT_CODE20,
    ACTIVE_INGREDIENT_CODE20_SUCCESS,
    ACTIVE_INGREDIENT_CODE20_ERROR,
    DOSAGE_FORM_CODE20,
    DOSAGE_FORM_CODE20_SUCCESS,
    DOSAGE_FORM_CODE20_ERROR,
    MED_DESCRIPTION_CODE22,
    MED_DESCRIPTION_CODE22_SUCCESS,
    MED_DESCRIPTION_CODE22_ERROR,
    SOURCE_CODE22,
    SOURCE_CODE22_SUCCESS,
    SOURCE_CODE22_ERROR,
    ANIO_PRICE_CODE22,
    ANIO_PRICE_CODE22_SUCCESS,
    ANIO_PRICE_CODE22_ERROR,
    UNIT_PRICE,
    UNIT_PRICE_SUCCESS,
    UNIT_PRICE_ERROR,
    UNIT_PRICE_TRANSACCIONES,
    UNIT_PRICE_TRANSACCIONES_SUCCESS,
    UNIT_PRICE_TRANSACCIONES_ERROR,
    BASKET,
    BASKET_SUCCESS,
    BASKET_ERROR
} from '../actions';

export const NAME = 'catalogList';


export const RouteAdministrationGroup = (filters) => ({
    type: ROUTE_ADMINISTRATION_GROUP,
    payload: { filters: filters }
});

export const RouteAdministrationGroupSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_SUCCESS,
  payload: data
});

export const RouteAdministrationGroupError = (error) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ERROR,
  payload: error
});

export const DosageFormGroup = (filters) => ({
    type: DOSAGE_FORM_GROUP,
    payload: { filters: filters }
});

export const DosageFormGroupSuccess = (data) => ({
    type: DOSAGE_FORM_GROUP_SUCCESS,
    payload: data
});

export const DosageFormGroupError = (error) => ({
    type: DOSAGE_FORM_GROUP_ERROR,
    payload: error
});


export const RouteAdministration = (filters) => ({
    type: ROUTE_ADMINISTRATION,
    payload: { filters: filters }
});

export const RouteAdministrationSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_SUCCESS,
    payload: data
});

export const RouteAdministrationError = (error) => ({
    type: ROUTE_ADMINISTRATION_ERROR,
    payload: error
});

export const DosageForm = (filters) => ({
    type: DOSAGE_FORM,
    payload: { filters: filters }
});

export const DosageFormSuccess = (data) => ({
    type: DOSAGE_FORM_SUCCESS,
    payload: data
});

export const DosageFormError = (error) => ({
    type: DOSAGE_FORM_ERROR,
    payload: error
});

export const DispensingUnit = (filters) => ({
    type: DISPENSING_UNIT,
    payload: { filters: filters }
});

export const DispensingUnitSuccess = (data) => ({
    type: DISPENSING_UNIT_SUCCESS,
    payload: data
});

export const DispensingUnitError = (error) => ({
    type: DISPENSING_UNIT_ERROR,
    payload: error
});

export const Unspsc = (filters) => ({
    type: UNSPSC,
    payload: { filters: filters }
});

export const UnspscSuccess = (data) => ({
    type: UNSPSC_SUCCESS,
    payload: data
});

export const UnspscError = (error) => ({
    type: UNSPSC_ERROR,
    payload: error
});

export const UnspscFamily = (filters) => ({
    type: UNSPSC_FAMILY,
    payload: { filters: filters }
});

export const UnspscFamilySuccess = (data) => ({
    type: UNSPSC_FAMILY_SUCCESS,
    payload: data
});

export const UnspscFamilyError = (error) => ({
    type: UNSPSC_FAMILY_ERROR,
    payload: error
});

export const UnspscClass = (filters) => ({
    type: UNSPSC_CLASS,
    payload: { filters: filters }
});

export const UnspscClassSuccess = (data) => ({
    type: UNSPSC_CLASS_SUCCESS,
    payload: data
});

export const UnspscClassError = (error) => ({
    type: UNSPSC_CLASS_ERROR,
    payload: error
});

export const ActiveIngredientCode20 = (filters) => ({
    type: ACTIVE_INGREDIENT_CODE20,
    payload: { filters: filters }
});

export const ActiveIngredientCode20Success = (data) => ({
    type: ACTIVE_INGREDIENT_CODE20_SUCCESS,
    payload: data
});

export const ActiveIngredientCode20Error = (error) => ({
    type: ACTIVE_INGREDIENT_CODE20_ERROR,
    payload: error
});

export const DosageFormCode20 = (filters) => ({
    type: DOSAGE_FORM_CODE20,
    payload: { filters: filters }
});

export const DosageFormCode20Success = (data) => ({
    type: DOSAGE_FORM_CODE20_SUCCESS,
    payload: data
});

export const DosageFormCode20Error = (error) => ({
    type: DOSAGE_FORM_CODE20_ERROR,
    payload: error
});

export const MedDescriptionCode22 = (filters) => ({
    type: MED_DESCRIPTION_CODE22,
    payload: { filters: filters }
});

export const MedDescriptionCode22Success = (data) => ({
    type: MED_DESCRIPTION_CODE22_SUCCESS,
    payload: data
});

export const MedDescriptionCode22Error = (error) => ({
    type: MED_DESCRIPTION_CODE22_ERROR,
    payload: error
});

export const SourceCode22 = (filters) => ({
    type: SOURCE_CODE22,
    payload: { filters: filters }
});

export const SourceCode22Success = (data) => ({
    type: SOURCE_CODE22_SUCCESS,
    payload: data
});

export const SourceCode22Error = (error) => ({
    type: SOURCE_CODE22_ERROR,
    payload: error
});

export const AnioPriceCode22 = (filters) => ({
    type: ANIO_PRICE_CODE22,
    payload: { filters: filters }
});

export const AnioPriceCode22Success = (data) => ({
    type: ANIO_PRICE_CODE22_SUCCESS,
    payload: data
});

export const AnioPriceCode22Error = (error) => ({
    type: ANIO_PRICE_CODE22_ERROR,
    payload: error
});

export const UnitPrice = (filters) => ({
    type: UNIT_PRICE,
    payload: { filters: filters }
});

export const UnitPriceSuccess = (data) => ({
    type: UNIT_PRICE_SUCCESS,
    payload: data
});

export const UnitPriceError = (error) => ({
    type: UNIT_PRICE_ERROR,
    payload: error
});

export const UnitPriceTransacciones = (filters) => ({
    type: UNIT_PRICE_TRANSACCIONES,
    payload: { filters: filters }
});

export const UnitPriceTransaccionesSuccess = (data) => ({
    type: UNIT_PRICE_TRANSACCIONES_SUCCESS,
    payload: data
});

export const UnitPriceTransaccionesError = (error) => ({
    type: UNIT_PRICE_TRANSACCIONES_ERROR,
    payload: error
});

export const Basket = (filters) => ({
    type: BASKET,
    payload: { filters: filters }
});

export const BasketSuccess = (data) => ({
    type: BASKET_SUCCESS,
    payload: data
});

export const BasketError = (error) => ({
    type: BASKET_ERROR,
    payload: error
});

const catalogList = (state) => state[NAME];

export const CatalogListSelector = createStructuredSelector({
  catalogList
})
